import clsx from "clsx";
import Cookies from "js-cookie";
import React, { useEffect, useState, useRef } from "react";
import { blob } from "stream/consumers";
import {
  MetaDataList,
  MetaDataDetails,
  MetaDataDetailsExecute,
  MetaDataDetailsDownload,
  GetApiData,
  GetDyanmicFormApiData,
  FetchSecurityMaster,
} from "../../api/api";
import { Button } from "../../components/Button/Button";
import { TableData } from "./tabledata";
import Switch from "react-switch";
import _ from "lodash";
import { MultiSelect } from "react-multi-select-component";
import { filter } from "lodash";
import { BASE_URL, API_KEY } from "../../api/api";
import moment from "moment";
import { Spinner } from "react-bootstrap";

interface ErrorItem {
  message: string;
  errorCode: string;
  stackTrace: string;
}

const TaskList = () => {
  const [metaDataList, setMetaDataList] = useState<any>();
  const [selectedId, setSelectedId] = useState<any>(null);
  const [getMetaValue, setGetMetaValue] = useState<any>(null);
  const [selectedName, setSelectedName] = useState<any>(null);
  const [getExecuteValue, setGetExecuteValue] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [getTaskDownload, setGetTaskDownload] = useState("");
  const [isDownload, setIsDownload] = useState(false);
  const [filterFundId, setFilterFundId] = useState<any>(null);
  const [getFundList, setGetFundList] = useState<any>(null);
  const [showControls, setShowControls] = useState<any>(null);
  const [ToggleButton, setToggleButton] = useState(false);
  const [inputValue, setInputValue] = useState(null);
  const [data, setData] = useState<any>("");
  const selectedClient: any = Cookies.get("client");
  const sessionID = Cookies.get("sessionId");
  const [fundList, setFundList] = useState<any>(null);
  const [participantList, setParticipantList] = useState<any>(null);
  const [returnType, setReturnType] = useState("dataset");
  const [filteredTaskOptions, setFilteredTaskOptions] = useState<any>([]);
  const [dateValue, setDateValue] = useState("");
  const [dataProcessErrorMsg, setDataProcessErrorMsg] = useState<any>("");
  const [dataSetErrorMsg, setDataSetErrorMsg] = useState<any>();
  const [errors, setErrors] = useState<any>([]);
  const [downloadSuccess, setDownloadSuccess] = useState("");
  const [permissionDenied, setPermissionDenied] = useState<any>("");
  const [showValidate, setShowValidate] = useState(false);
  const [showProcessErrors, setShowProcessErrors] = useState<any>("");
  const [isActive, setIsActive] = useState(false);

  function handleDateChange(e: any) {
    const { name, value } = e.target;
    setDateValue(e.target.value);

    // Parse dates for comparison
    const endDate = new Date(data?.EndDate);
    const newValue = new Date(value);

    // Check if Begin Date is greater than End Date
    if (name === "BeginDate" && newValue > endDate) {
      console.error("Error: Begin Date cannot be greater than End Date");
      return;
    }

    return setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  }

  function handleProcessSecurity() {
    if (
      selectedId !== null &&
      selectedDate !== null &&
      selectedName !== "ExportSecurityPositionsData"
    ) {
      MetaDataDetailsExecute(selectedName, selectedDate, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetExecuteValue(response);
          setSectorCount(response);
        });
    }
  }

  function handleDownload(e: any) {
    return setGetTaskDownload(e.target.value);
  }

  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setGetExecuteValue(
      sectorCount.slice(pageNumbers * 15 - 15, pageNumbers * 15)
    );
    setSectorCurrentPage(pageNumbers);
  };

  useEffect(() => {
    if (
      filterFundId !== null &&
      selectedId === "6982dd6e-a482-4fb5-b103-2028e454a6d8"
    ) {
      const FundId = filterFundId?.id;
      GetApiData(FundId, "Fund", Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          setGetFundList(response);
        });
    }
  }, [filterFundId]);

  const handleSelectChange = (e: any) => {};
  const handleSelectFundChange = (e: any) => {
    return console.log(e);
  };

  const [selected, setSelected] = useState<any>([]);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (selected[0]?.value) {
      setData(null);
      setDataSetErrorMsg(null);
      setDateValue("");
      setDownloadSuccess("");
    }
    // Additional logic or function calls based on the updated value of "selected"
  }, [selected]);

  useEffect(() => {
    if (selected.length > 1) {
      setSelected([selected[selected.length - 1]]);
      setData(null);
      setDateValue("");
      setDownloadSuccess("");
      setPermissionDenied("");
    }
    if (selected) {
      setShowProcessErrors(null);
      setIsActive(false);
      setGetTaskDownload("");
    }
  }, [selected]);

  useEffect(() => {
    let selectedResult = selected.map((value: any) => value);
    var taskItem = selectedResult.find((e: any) => e.value);
    setSelectedId(taskItem?.value);
    setSelectedName(taskItem?.label);
  }, [selected]);
  useEffect(() => {
    if (selectedId) {
      MetaDataDetails(selectedId, selectedClient, Cookies.get("newJwt"))
        .then((response) => response.json())
        .then((response) => {
          const updatedData = response.filter(
            (item: any) => item.name !== "SessionID"
          );
          setGetMetaValue(response);
          setFilterFundId(_.find(response, ["name", "FundID"]));
        });
    }
  }, [selectedId]);

  useEffect(() => {
    const a = _.find(metaDataList, ["name", selectedName]);
    setShowControls(a);
  }, [selectedName]);

  useEffect(() => {
    MetaDataList(selectedClient, Cookies.get("newJwt"))
      .then((response) => response)
      .then((response) => {
        setMetaDataList(response);
      });
  }, []);

  const updateData = (e: any) => {
    setData({
      ...data,
      [e.target.name]:
        e.target.type === "number" ? parseInt(e.target.value) : e.target.value,
    });
  };
  const handleChangeSwitch = (e: any) => {
    setToggleButton({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setDataSetErrorMsg(null);
    setDownloadSuccess("");
    setPermissionDenied("");
  }, [getTaskDownload, ToggleButton, data]);

  let labelList: any[] = getMetaValue?.map((e: any) => e.name) || [];

  useEffect(() => {}, []);

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    setIsActive(true);
    const formData = new FormData(e.currentTarget);

    let rawData: any[] = [];

    for (const [name, value] of formData) {
      rawData.push(`${name}: ${value}`);
    }

    // Function to extract parameter name and value from a string
    const extractParam = (str: any) => {
      const [name, value] = str.split(":").map((item: any) => item.trim());
      return { name, value };
    };

    // Check if ParticipantID is empty
    const participantParam = rawData.find(
      (str) => extractParam(str).name === "ParticipantID"
    );
    const participantValue = participantParam
      ? extractParam(participantParam).value
      : "";

    interface FormattedData {
      [key: string]: string;
    }
    // Helper function to extract key and value from a string
    function prepareFormattedData(dataArray: any) {
      const formattedData: FormattedData = {};

      dataArray.forEach((entry: any) => {
        const [key, value] = entry
          .replace(/[[\]']/g, "")
          .split(": ")
          .map((item: any) => item.trim());
        formattedData[key] = value;
      });

      return formattedData;
    }

    // Process the raw data
    const formattedData = prepareFormattedData(rawData);

    var token = Cookies.get("newJwt");
    setIsDownload(true);
    let extension = "";
    if (`${getTaskDownload}` === "pdf") {
      extension = "pdf";
    }
    if (`${getTaskDownload}` === "csv") {
      extension = "csv";
    }
    if (`${getTaskDownload}` === "excel") {
      extension = "xlsx";
    }
    const containsClientID = getMetaValue.some(
      (meta: any) => meta.name === "ClientID"
    );

    const containsSessionID = getMetaValue.some(
      (meta: any) => meta.name === "SessionID"
    );
    let downloadOptions;

    if (getTaskDownload === "") {
      if (showControls?.allowPdfExport === true) {
        downloadOptions = "pdf";
        extension = "pdf";
      } else if (showControls?.allowPdfExport !== true) {
        downloadOptions = "excel";
        extension = "xlsx";
      } else if (showControls?.allowExcelExport !== true) {
        downloadOptions = "csv";
        extension = "csv";
      }
    } else {
      downloadOptions = getTaskDownload;
    }

    if (
      (formattedData.EndDate ||
        formattedData.BeginDate ||
        formattedData.Date) &&
      getMetaValue.some(
        (field: any) =>
          (field.name === "EndDate" ||
            field.name === "BeginDate" ||
            field.name === "Date") &&
          field.dbType === "datetime"
      )
    ) {
      if (formattedData.EndDate) {
        const endDate = moment(formattedData.EndDate).format(
          "yyyy-MM-DD HH:mm:ss"
        );
        formattedData.EndDate = endDate;
      }

      if (formattedData.BeginDate) {
        const beginDate = moment(formattedData.BeginDate).format(
          "yyyy-MM-DD HH:mm:ss"
        );
        formattedData.BeginDate = beginDate;
      }
      if (formattedData.Date) {
        const DateNew = moment(formattedData.Date).format(
          "yyyy-MM-DD HH:mm:ss"
        );
        formattedData.Date = DateNew;
      }
    }

    var raw;
    if (showControls?.returnType === "dataset") {
      raw = JSON.stringify({
        Type: downloadOptions,
        data: {
          ...formattedData,
          ...(containsClientID ? { ClientID: parseInt(selectedClient) } : null),
          ...(containsSessionID ? { SessionID: sessionID } : null),
        },
      });
    } else {
      raw = JSON.stringify({
        data: {
          ...formattedData,
          ...(containsClientID ? { ClientID: parseInt(selectedClient) } : null),
          ...(containsSessionID ? { SessionID: sessionID } : null),
        },
      });
    }

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        clientId: selectedClient,
      },
      body: raw,
    };
    if (showControls?.returnType === "dataset") {
      fetch(
        `${BASE_URL}/${API_KEY}/api/metadata/${showControls?.id}/download`,
        requestOptions
      )
        .then((response) => {
          if (response.ok) {
            response.blob().then((blob) => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = `sample.${extension}`;
              alink.click();
              setIsDownload(false);
              setDownloadSuccess("File downloaded successfully!");
              setIsActive(false);
            });
          } else {
            return response.json().then((data) => {
              setDataSetErrorMsg(data?.errors[0]?.message);
              setPermissionDenied(data?.errorMessage);
              setIsActive(false);
              throw new Error(data.errorMessage);
            });
          }
        })

        .catch((error) => {
          setErrors(error);
        });
    }
    if (showControls?.returnType === "dataprocess") {
      fetch(
        `${BASE_URL}/${API_KEY}/api/metadata/${showControls?.id}/execute`,
        requestOptions
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data && data.errors && data.errors.length > 0) {
            setShowProcessErrors(data);
          } else {
            setGetExecuteValue(data);
            setShowProcessErrors(data);
          }
          setIsActive(false);
          setGetExecuteValue(data);
          setShowProcessErrors(data);
        })
        .catch((error) => {
          setIsActive(false);
          console.error("Error fetching data:", error);
          setDataSetErrorMsg("An error occurred while fetching data.");
        });
    }
  };

  useEffect(() => {
    FetchSecurityMaster(
      "Fund",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setFundList(response);
    });
    FetchSecurityMaster(
      "Participant",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setParticipantList(response);
    });
  }, []);

  const handleRadioChange = (event: any) => {
    setReturnType(event.target.value);
  };

  useEffect(() => {
    const returnTypeFilter = returnType || "dataset";
    const filteredOptions = filter(metaDataList, {
      returnType: returnTypeFilter,
    });
    setFilteredTaskOptions(filteredOptions);
    setSelectedId(null);
    setSelected([]);
    setDateValue("");
    setDataSetErrorMsg(null);
    setDataSetErrorMsg(null);
    setData(null);
  }, [returnType, metaDataList]);

  const taskOptions: any = filteredTaskOptions?.map((e: any) => {
    return { label: e.name, value: e.id };
  });

  const currentDate = moment();
  const currentWeekOfMonth = Math.ceil(currentDate.date() / 7);

  let startDate = currentDate.format("YYYY-MM-DD");
  let endDate = currentDate.format("YYYY-MM-DD"); // Default to current date

  if (
    currentWeekOfMonth === 1 ||
    currentWeekOfMonth === 2 ||
    currentWeekOfMonth === 3 ||
    currentWeekOfMonth === 4 ||
    currentWeekOfMonth === 5
  ) {
    const previousMonth = currentDate.clone().subtract(1, "months");
    startDate = previousMonth.startOf("month").format("YYYY-MM-DD");
    endDate = previousMonth.endOf("month").format("YYYY-MM-DD");
  }

  return (
    <div>
      <div className="header">
        <h1 className="header-title">Task</h1>
      </div>

      <div className="row w-100 card p-4">
        {downloadSuccess ? (
          <div
            className="alert position-absolute start-0 px-4 alert-success p-2"
            style={{ top: "-30px" }}
            role="alert"
          >
            {downloadSuccess}
          </div>
        ) : null}
        {permissionDenied || dataSetErrorMsg ? (
          <div
            className="alert position-absolute start-0 px-4 alert-danger p-2"
            style={{ top: "-30px" }}
            role="alert"
          >
            {permissionDenied && permissionDenied}
            {dataSetErrorMsg && dataSetErrorMsg}
          </div>
        ) : null}
        {showProcessErrors &&
        showProcessErrors?.errors &&
        showProcessErrors?.errors?.length > 0 ? (
          <div
            className="alert position-absolute start-0 px-4 alert-danger p-2"
            style={{ top: "-30px" }}
            role="alert"
          >
            {showProcessErrors?.errors[0]?.message}
          </div>
        ) : null}

        {showProcessErrors &&
        showProcessErrors &&
        showProcessErrors?.length > 0 &&
        showProcessErrors[0]?.ProcessResultCode &&
        showProcessErrors[0]?.ProcessResultCode !== 0 ? (
          <div
            className="alert position-absolute start-0 px-4 alert-danger p-2"
            style={{ top: "-30px" }}
            role="alert"
          >
            {showProcessErrors[0]?.ProcessResultDesc}
          </div>
        ) : null}
        {showProcessErrors &&
        showProcessErrors &&
        showProcessErrors?.length > 0 &&
        showProcessErrors[0]?.ProcessResultCode === 0 ? (
          <div
            className="alert position-absolute start-0 px-4 alert-success p-2"
            style={{ top: "-30px" }}
            role="alert"
          >
            {showProcessErrors[0]?.ProcessResultDesc}
          </div>
        ) : null}

        <div className="w-100 tradeForm position-relative">
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">Select:</label>
            <div className="col-sm-10 px-2 d-flex">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  value="dataset"
                  onChange={handleRadioChange}
                  checked={returnType === "dataset"}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault2">
                  Data Views
                </label>
              </div>
              <div className="form-check mx-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  value="dataprocess"
                  onChange={handleRadioChange}
                  checked={returnType === "dataprocess"}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Data Process
                </label>
              </div>
            </div>
          </div>
          <div className="form-group row pt-2">
            <label className="col-sm-2 col-form-label">Task:</label>
            <div className="col-sm-10 px-2">
              {taskOptions ? (
                <MultiSelect
                  options={taskOptions}
                  value={selected}
                  hasSelectAll={false}
                  onChange={setSelected}
                  labelledBy="Select Benchmark"
                  className="multiSelect w-25 taskSelection"
                  closeOnChangedValue={true}
                />
              ) : null}

              {/* <select className="form-control w-25" onChange={handleChange}>
                <option>Select</option>
                {metaDataList ? (
                  metaDataList &&
                  metaDataList.map((e: any) => {
                    return (
                      <option key={e.id} id={e.id}>
                        {e.name}
                      </option>
                    );
                  })
                ) : (
                  <option value="">Loading...</option>
                )}
              </select> */}
            </div>
          </div>

          <form onSubmit={handleFormSubmit}>
            {selectedId && selectedId !== null ? (
              <>
                <div className="form-group row py-2">
                  {getMetaValue?.map((e: any, index: any) => {
                    return e.parameterType === "IN" &&
                      e.label !== "ClientID" &&
                      e.label !== "SessionID" ? (
                      <div className="d-flex py-2">
                        <label className="col-form-label col-sm-2">
                          {e.label}
                        </label>

                        <div className="col-sm-10">
                          {/* {e.name === "FundID" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            >
                              
                              {getFundList?.map((item: any) => {
                                return (
                                  <option
                                    defaultValue="select"
                                    value={item.fundID}
                                  >
                                    {item.fundName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null} */}
                          {e.inputType.toLowerCase() === "select" ? (
                            <>
                              {e.options.length > 0 ? (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                  key={selected}
                                >
                                  <option value="">Select</option>

                                  {e.options.map((item: any) => {
                                    return (
                                      <option value={item.value}>
                                        {item.label}
                                      </option>
                                    );
                                  })}
                                </select>
                              ) : (
                                <select
                                  className="form-control w-25"
                                  name={e.label}
                                  onChange={updateData}
                                  key={selected}
                                >
                                  <option value="">Select</option>

                                  {e.inputDataSource.map((item: any) => {
                                    return (
                                      <option
                                        value={item?.parameterData?.[0].key}
                                      >
                                        {item?.parameterData?.[0].val}
                                      </option>
                                    );
                                  })}
                                </select>
                              )}
                            </>
                          ) : null}
                          {e.inputType.toLowerCase() === "SelectList" ? (
                            <select
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              <option value="">
                                {e.inputDataSource.map((item: any) => {
                                  return item.value;
                                })}
                              </option>
                            </select>
                          ) : null}
                          {e.label === "FundID" || e.label === "Fund" ? (
                            <select
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              {fundList?.map((fund: any) => {
                                return (
                                  <option
                                    value={fund?.fundID}
                                    key={fund?.fundID}
                                    selected={
                                      fundList.length === 1
                                        ? fundList[0]?.fundID
                                        : selected
                                    }
                                  >
                                    {fund.fund}- {fund.fundName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null}
                          {e.label === "ParticipantID" ||
                          e.label === "Participant" ? (
                            <select
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            >
                              <option value="">Select</option>
                              {participantList?.map((e: any) => {
                                return (
                                  <option
                                    value={e.participantID}
                                    key={e.participantID}
                                  >
                                    {e.participantNumber}- {e.participantName}
                                  </option>
                                );
                              })}
                            </select>
                          ) : null}
                          {e.inputType.toLowerCase() === "text" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              name={e.label}
                              className="form-control w-25"
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "file" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "number" &&
                          e.label !== "FundID" &&
                          e.label !== "ParticipantID" &&
                          e.label !== "Fund" &&
                          e.label !== "Participant" &&
                          e.label !== "ClientID" ? (
                            <input
                              type={e.inputType}
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "maskedtext" ? (
                            <input
                              type="text"
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              name={e.name}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "date" &&
                          e.dbType === "smalldatetime" &&
                          e.label === "BeginDate" ? (
                            <input
                              type="date"
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                              //key={selected}
                              defaultValue={startDate}
                              max={data?.EndDate || ""}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "date" &&
                          e.dbType === "smalldatetime" &&
                          e.label === "EndDate" ? (
                            <input
                              type="date"
                              placeholder="mm-dd-yyyy"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                              //key={selected}
                              defaultValue={endDate}
                            />
                          ) : null}
                          {e.inputType.toLowerCase() === "date" &&
                          e.dbType === "datetime" ? (
                            <input
                              type="datetime-local"
                              placeholder="mm-dd-yyyy12"
                              className="form-control w-25"
                              name={e.label}
                              onChange={handleDateChange}
                              key={selected}
                              defaultValue={
                                selectedDate || e.label === "BeginDate"
                                  ? `${startDate}00:00:00`
                                  : `${endDate}00:00:00`
                              }
                            />
                          ) : null}
                          {e.inputType === "textarea" ? (
                            <textarea
                              placeholder={e.placeHolder}
                              className="form-control w-25"
                              //rows="3"
                              name={e.label}
                              onChange={updateData}
                              key={selected}
                            />
                          ) : null}
                          {e.inputType === "radio" ? (
                            <>
                              <form name={e.name} onChange={updateData}>
                                {e.options.map((item: any) => {
                                  return (
                                    <div className="form-check form-check-inline py-1">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="inlineRadio1"
                                        value={item.value}
                                        name={e.name}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio1"
                                      >
                                        {item.label}
                                      </label>
                                    </div>
                                  );
                                })}
                              </form>
                            </>
                          ) : null}

                          {e.inputType === "checkboxgroup" ? (
                            <form name={e.name} onChange={updateData}>
                              {e.options.map((item: any) => {
                                return (
                                  <div className="form-check form-check-inline py-1">
                                    <input
                                      type="checkbox"
                                      placeholder={e.placeHolder}
                                      className="form-check-input my-2"
                                      name={e.label}
                                      onChange={updateData}
                                    />
                                    <label
                                      className="form-check-label py-1"
                                      htmlFor="inlineCheckBOx1"
                                    >
                                      {item.label}
                                    </label>
                                  </div>
                                );
                              })}
                            </form>
                          ) : null}

                          {e.inputType === "switch" ? (
                            <Switch
                              checked={ToggleButton}
                              onChange={handleChangeSwitch}
                              onColor="#33B271"
                              onHandleColor="#fff"
                              handleDiameter={30}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={48}
                              className="react-switch my-2"
                              name={e.label}
                              //onChange={() => updateData((current:any) => !current)}
                            />
                          ) : null}
                          {e.inputType === "button" ? (
                            <button className="btn btn-primary">
                              {e?.label}
                            </button>
                          ) : null}
                        </div>
                      </div>
                    ) : null;
                  })}{" "}
                  {showControls?.allowExecute === true &&
                  showControls?.returnType === "dataset" ? (
                    <div className="d-flex py-2">
                      <label className="col-sm-2 col-form-label">
                        Download
                      </label>
                      <div className="col-sm-10">
                        <select
                          className="form-control w-25"
                          onChange={handleDownload}
                          key={selected}
                        >
                          <option value="">Select</option>

                          {showControls?.allowPdfExport === true && (
                            <option value="pdf" selected>
                              PDF
                            </option>
                          )}
                          {showControls?.allowCsvExport === true && (
                            <option
                              value="csv"
                              selected={
                                showControls?.allowPdfExport !== true &&
                                showControls?.allowExcelExport !== true
                              }
                            >
                              CSV
                            </option>
                          )}
                          {showControls?.allowExcelExport === true && (
                            <option
                              value="excel"
                              selected={showControls?.allowPdfExport !== true}
                            >
                              Excel
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-sm-12 my-4 p-0">
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center btn-xs btn btn-link float-start"
                    >
                      {showControls?.cancelButtonText !== null
                        ? showControls?.cancelButtonText
                        : "Cancel"}
                    </button>
                    <button
                      type="submit"
                      disabled={isActive}
                      className="btn d-inline-flex align-items-center btn-xs btn btn-primary float-start mx-4"
                    >
                      {showControls?.submitButtonText !== null
                        ? showControls?.submitButtonText
                        : "Submit"}
                      {isActive ? <Spinner size="sm" className="ms-1" /> : null}
                    </button>
                  </div>
                </div>
              </>
            ) : null}
          </form>
          {selectedName && selectedName === "ProcessSecurityPositionsData" ? (
            <div className="col-sm-12 mb-4">
              <Button
                children="Submit"
                type="button"
                className="btn btn-primary float-end"
                size="btn-xs"
                onClick={handleProcessSecurity}
                showLoading={isDownload}
              />
            </div>
          ) : null}
          {selectedName &&
          selectedName === "GetSecurityPositionsData" &&
          selectedDate !== "" ? (
            <TableData
              selectedId={selectedId}
              selectedDate={selectedDate}
              getExecuteValue={getExecuteValue}
              sectorCount={sectorCount}
              SectorpageHandler={SectorpageHandler}
              SectorCurrentPage={SectorCurrentPage}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export { TaskList };
